<ng-container *ngIf="selectedCompany">
	<div class="menu-item px-5">
		<h3 class="col-12 fw-bold p-3" translate>active_company_header_navbar</h3>
		<div class="menu-content d-flex align-items-center px-3">
			@if (selectedCompany.companyLogo?.file?.path) {
				<div class="symbol symbol-50px me-5">
					<span class="symbol-label">
						<img [src]="selectedCompany.companyLogo?.file?.path" class="h-50px w-50px align-self-center pay-obj-fit p-2" alt="Company Logo" />
					</span>
				</div>
			} @else {
				<div class="symbol symbol-50px w-50px bg-light me-3">
					<img src="../../../../../../../customization/assets/spotside-pay-ico.svg" alt="" class="h-50px w-50px align-self-center pay-obj-fit p-2" />
				</div>
			}
			<span class="fw-bold text-muted fs-7">
				{{ selectedCompany.legalName }}
			</span>
		</div>
	</div>

	<div class="separator my-2"></div>

	<div class="menu-item px-5">
		<a class="menu-link px-5" routerLink="/edit-company" translate (click)="openEditCompany()">
			<span class="menu-icon">
				<app-keenicon name="office-bag" class="fs-2"></app-keenicon>
			</span>
			active_company_informations_header_navbar
		</a>
	</div>

	<div class="menu-item px-5">
		<a class="menu-link px-5 cursor-pointer" routerLink="/user-management" routerLinkActive="active" translate (click)="openUser()">
			<span class="menu-icon">
				<app-keenicon name="profile-user" class="fs-2"></app-keenicon>
			</span>
			active_company_users_header_navbar
		</a>
	</div>

	<div class="menu-item px-5">
		<a class="menu-link px-5 cursor-pointer" routerLink="/roles" routerLinkActive="active" translate (click)="openRoles()">
			<span class="menu-icon">
				<app-keenicon name="user-square" class="fs-2"></app-keenicon>
			</span>
			active_company_roles_header_navbar
		</a>
	</div>
</ng-container>
